import { html, LitElement } from "lit-element";
import { styleMap } from "lit-html/directives/style-map";
import { paths } from "../resources";
/**
 * Attribute
 *   progress: 0부터 100 사이의 값
 */
export class Loading extends LitElement {
    constructor() {
        super(...arguments);
        this.progress = 0;
    }
    static get properties() {
        return {
            progress: { type: String },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `<img class="absolute" src="${paths.loadingWaitingGif}" />
      <img class="absolute" src="${paths.loadingBar}" />
      <jh-360-video-rect
        widthRatio="${this.progress / 100}"
      ></jh-360-video-rect>`;
    }
}
customElements.define("jh-360-video-loading", Loading);
class Rect extends LitElement {
    constructor() {
        super(...arguments);
        this.widthRatio = 0;
    }
    static get properties() {
        return {
            widthRatio: { type: Number },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        const style = {
            top: "668px",
            left: "194px",
            width: `${this.widthRatio * 333}px`,
            height: "5px",
            "background-color": "red",
        };
        return html `<div style="${styleMap(style)}" class="absolute"></div>`;
    }
}
customElements.define("jh-360-video-rect", Rect);
//# sourceMappingURL=loading.js.map